import React from 'react';
import LottieAnimation from '../assets/Animations/Lottie';
import animationData from '../assets/Animations/landing-page-contact-us';
import afterLoading from '../assets/Animations/contact-us-page';
import PropTypes from 'prop-types';
import { Button, TextField } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import fetch from 'cross-fetch';


const styles = theme => ({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    textField: {
      marginLeft: '15%',
      width: '70%',
      color: 'white'
    },
    cssLabel: {
      color : '#90be4e'
    },
  
    cssOutlinedInput: {
      '&$cssFocused $notchedOutline': {
        borderColor: `${theme.palette.primary.main} !important`,
      }
    },
  
    cssFocused: {
        color: '#c5c5c5'
    },
  
    notchedOutline: {
      borderWidth: '1px',
      borderColor: '#c5c5c5 !important'
    },
  
  });


class Contact extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            isLoading: true,
            name: "",
            email: "",
            message: ""
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.formIsValid = this.formIsValid.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.PostContactForm = this.PostContactForm.bind(this);
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({isLoading: false})
        }, 5000);
    }

    handleInputChange(event) {
        const target = event.target;
        const name = target.name;
        this.setState({
            [name]: target.value
        });
    }

    validateEmail(){
        const email = this.state.email;
        const isEvalid = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
        if (isEvalid){
            return true;
        }
        return false;
    }


    formIsValid(){
        const isVal = this.validateEmail();
        if (isVal && this.state.message && this.state.name){
            return true
        }
        else {
            return false
        }
    }

    handleFormSubmit(e){
        if (this.validateEmail()){
            this.PostContactForm(this.state.name, this.state.email, this.state.message, e);
        }
    }

    PostContactForm = (name, email, message, event) => {
        const mess = {
            'name': name,
            'email': email,
            'message': message
        }
    
        fetch('https://hmp-mail-api.herokuapp.com/send', {
                method: 'POST',
                body: JSON.stringify(mess),
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': 'https://hmp-mail-api.herokuapp.com/send',
                    'Access-Control-Allow-Methods': ["POST", "GET", "OPTIONS", "DELETE", "PUT"]
                }
            }, { mode: 'cors' })
                .then(response => {
                    if (response.ok) {
                        return response;
                    }
                    else {
                        let error = new Error(response.status + ' Error: ' + response.statusText);
                        error.response = error;
                        throw error
                    }
                },
                    error => {
                        let errmess = new Error(error.message);
                        throw errmess;
                    })
                .then(response => response.json())
                .then(alert(`Thanks for Contacting me!\n Please wait for my response`))
                .catch(error => { alert('I haven\'t received you message. Please try other options\nError: ' + error.message); });
                event.preventDefault();
        };

    

    render(){
        const { classes } = this.props;
        return (
            this.state.isLoading ? <LottieAnimation lotti={animationData} height={'auto'} width={'40%'} isloop={true}/>
            :
            <div id="contact">
                <LottieAnimation lotti={afterLoading} height={'auto'} width={'40%'} isloop={false} />

                <form autoComplete="off" onSubmit={this.handleFormSubmit}>  
                    <TextField id="outlined-basic fields" className={classes.textField} name="name" value={this.state.name} onChange={this.handleInputChange} label="Your Name" fullWidth autoComplete="none"
                        InputLabelProps={{
                            classes: {
                            root: classes.cssLabel,
                            focused: classes.cssFocused,
                            },
                        }}
                        InputProps={{
                            classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline,
                            },
                            inputMode: "numeric"
                        }}
                        error={this.state.name !== "" && !this.state.name.match("^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$")}
                        helperText={this.state.name !== "" && !this.state.name.match("^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$") ? "Is it your name or a Joke, let me know in message by entering your name here." : " "}
                    />   
                    <TextField id="outlined-basic fields"  className={classes.textField} name="email" value={this.state.email} onChange={this.handleInputChange} label="Email" fullWidth autoComplete="none"
                        InputLabelProps={{
                            classes: {
                            root: classes.cssLabel,
                            focused: classes.cssFocused,
                            },
                        }}
                        InputProps={{
                            classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline,
                            },
                            inputMode: "numeric"
                        }}
                        error={this.state.email !== "" && !this.validateEmail()}
                        helperText={this.state.email !== "" && !this.validateEmail() ? 'Please enter correct Email Address.' : ' '}
                    />   
                    <TextField id="outlined-basic fields" className={classes.textField} name="message" value={this.state.message} onChange={this.handleInputChange} label="Message" fullWidth multiline rows={5} autoComplete="none"
                        InputLabelProps={{
                            classes: {
                            root: classes.cssLabel,
                            focused: classes.cssFocused,
                            },
                        }}
                        InputProps={{
                            classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline,
                            },
                            inputMode: "numeric"
                        }}
                    /> 
                    <Button id="submitbtn" type="submit" disabled={!this.formIsValid()}>Submit</Button>   
                </form> 

            </div>
        );
    }
}


Contact.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
  export default withStyles(styles)(Contact);
